import VideoPlayer from "@/components/common/VideoPlayer";
import Thumbnail from "@/components/site-builder/modules/VideoModule/Thumbnail";
import { type AspectRatio, type VideoDisplayVariant } from "@/constants/media";
import type { VideoGalleryBlock } from "../types";

export interface PlayerProps {
  block: VideoGalleryBlock;
  aspectRatio: AspectRatio;
  openIn: VideoDisplayVariant;
}

export default function Player(props: PlayerProps) {
  const { block, aspectRatio, openIn } = props;

  return (
    <VideoPlayer
      source={block.videoSource}
      videoId={block.videoId}
      renderThumb={() => (
        <Thumbnail
          source={block.videoSource}
          videoId={block.videoId}
          thumbnail={block.customThumbnail}
          size="small"
        />
      )}
      aspectRatio={aspectRatio}
      openIn={openIn}
    />
  );
}
